import { Link, NavLink, useNavigate } from "react-router-dom";
import { clearAuth, getAdmin } from "../lib/api";
import { LayoutDashboard, Users, BookOpen, LogOut, Leaf, Calendar, Scroll } from "lucide-react";

const linkBase =
  "flex items-center gap-3 px-4 py-2.5 rounded-md text-[15px] transition-colors";
const linkIdle = "text-[hsl(var(--brand-muted))] hover:bg-[hsl(var(--brand-cream-deep))] hover:text-[hsl(var(--brand-ink))]";
const linkActive = "bg-[hsl(var(--brand-sage))] text-white hover:bg-[hsl(var(--brand-sage-hover))] hover:text-white";

export default function AdminLayout({ children }) {
  const admin = getAdmin();
  const nav = useNavigate();
  const logout = () => {
    clearAuth();
    nav("/admin/login");
  };

  return (
    <div className="min-h-screen grid grid-cols-1 md:grid-cols-[260px_1fr]" data-testid="admin-layout">
      <aside className="border-r border-[hsl(var(--brand-border))] bg-[hsl(var(--brand-cream))] p-6 flex md:flex-col gap-4 md:gap-0 items-start md:sticky md:top-0 md:h-screen">
        <Link to="/admin/dashboard" className="flex items-center gap-2 mb-0 md:mb-10" data-testid="admin-logo-link">
          <div className="w-9 h-9 rounded-full bg-[hsl(var(--brand-sage))] text-white grid place-items-center">
            <Leaf className="w-5 h-5" />
          </div>
          <div>
            <div className="font-display text-2xl leading-none">Nourish</div>
            <div className="text-xs tracking-[0.2em] uppercase text-[hsl(var(--brand-muted))] mt-1">Admin</div>
          </div>
        </Link>
        <nav className="ml-auto md:ml-0 flex md:flex-col gap-1 flex-1 md:w-full overflow-x-auto md:overflow-visible">
          <NavLink to="/admin/dashboard" className={({isActive}) => `${linkBase} ${isActive ? linkActive : linkIdle}`} data-testid="nav-dashboard">
            <LayoutDashboard className="w-4 h-4" /> Dashboard
          </NavLink>
          <NavLink to="/admin/clients" className={({isActive}) => `${linkBase} ${isActive ? linkActive : linkIdle}`} data-testid="nav-clients">
            <Users className="w-4 h-4" /> Clients
          </NavLink>
          <NavLink to="/admin/calendar" className={({isActive}) => `${linkBase} ${isActive ? linkActive : linkIdle}`} data-testid="nav-calendar">
            <Calendar className="w-4 h-4" /> Calendar
          </NavLink>
          <NavLink to="/admin/recipes" className={({isActive}) => `${linkBase} ${isActive ? linkActive : linkIdle}`} data-testid="nav-recipes">
            <BookOpen className="w-4 h-4" /> Recipes
          </NavLink>
          <NavLink to="/admin/guidelines" className={({isActive}) => `${linkBase} ${isActive ? linkActive : linkIdle}`} data-testid="nav-guidelines">
            <Scroll className="w-4 h-4" /> Guidelines
          </NavLink>
        </nav>
        <div className="hidden md:block w-full pt-6 border-t border-[hsl(var(--brand-border))]">
          <div className="text-sm font-medium text-[hsl(var(--brand-ink))] truncate">{admin?.name || "Admin"}</div>
          <div className="text-xs text-[hsl(var(--brand-muted))] truncate">{admin?.email}</div>
          <button
            onClick={logout}
            className={`${linkBase} ${linkIdle} w-full mt-3 text-left`}
            data-testid="admin-logout-btn"
          >
            <LogOut className="w-4 h-4" /> Sign out
          </button>
        </div>
      </aside>
      <main className="min-h-screen px-6 py-8 md:px-12 md:py-12">{children}</main>
    </div>
  );
}
